import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';
import {
  isCalendarDateBefore,
  isCalendarDateOnOrAfter,
  parseDate,
  serializeDateForApi
} from '../dates/dateService';

function coerceCalendarDate(value) {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  return parseDate(value);
}

export {
  ApiResponseError as MesasApiError,
  ApiSessionTimeoutError as MesasSessionTimeoutError,
  classifyApiError as classifyMesasError,
  unwrapResponseModel
};

export function formatMesaApiDate(date) {
  return serializeDateForApi(date);
}

export function formatMesaPeriodoDescripcion(mesa) {
  return [
    (mesa.periodoExamenDescripcion || '').trim(),
    (mesa.periodoExamenLlamado || '').trim(),
    (mesa.anioAcademicoDescripcion || '').trim(),
  ].filter(Boolean).join(' - ');
}

export function formatMesaPeriodoConLlamado(mesa) {
  return [
    (mesa.periodoExamenDescripcion || '').trim(),
    (mesa.periodoExamenLlamado || '').trim(),
  ].filter(Boolean).join(' - ');
}

export function parseLookupMesaExamenValue(value) {
  const parts = value.split('%');
  return {
    mesaExamenCod: parts[0] || '',
    materiaCarreraCodigo: (parts[1] || '').trim(),
    materiaCarreraNombre: (parts[2] || '').trim(),
    carreraNombre: (parts[3] || '').trim(),
    anioAcademicoDescripcion: (parts[4] || '').trim(),
    periodoExamenDescripcion: (parts[5] || '').trim(),
    periodoExamenLlamado: (parts[6] || '').trim(),
    materiaCarreraCod: (parts[7] || '').trim(),
  };
}

export function formatMesaExamenInscripcionDisplay(mesa) {
  const codigo = (mesa.materiaCarreraCodigo || '').trim();
  const nombre = (mesa.materiaCarreraNombre || '').trim();
  const carrera = (mesa.carreraNombre || '').trim();
  const periodo = formatMesaPeriodoDescripcion(mesa);
  const materiaLine = codigo ? `${codigo} - ${nombre}` : nombre;
  return [materiaLine, carrera, periodo].filter(Boolean).join(' - ');
}

export function formatMesaExamenInscripcionCardDisplay(mesa) {
  const nombre = (mesa.materiaCarreraNombre || '').trim();
  const carrera = (mesa.carreraNombre || '').trim();
  const periodo = formatMesaPeriodoDescripcion(mesa);
  return [nombre, carrera, periodo].filter(Boolean).join(' - ');
}

export function buildLookupMesaExamenValue(mesa) {
  return [
    mesa.mesaExamenCod,
    mesa.materiaCarreraCodigo || '',
    mesa.materiaCarreraNombre,
    mesa.carreraNombre,
    mesa.anioAcademicoDescripcion,
    mesa.periodoExamenDescripcion,
    mesa.periodoExamenLlamado,
    mesa.materiaCarreraCod,
  ].join('%');
}

export function toCreateMesaPayload({
  fechaExamen,
  fechaInicioInscripcion,
  fechaFinInscripcion,
  periodoExamenCod,
  materiaCarreraCod
}) {
  return {
    MesaExamenFechaExamen: formatMesaApiDate(fechaExamen),
    MesaExamenFechaInicioInscripci: formatMesaApiDate(fechaInicioInscripcion),
    MesaExamenFechaFinInscripcion: formatMesaApiDate(fechaFinInscripcion),
    PeridoExamenCod: periodoExamenCod,
    MateriaCarreraCod: materiaCarreraCod
  };
}

export function toUpdateMesaPayload({
  id,
  periodoExamenCod,
  materiaCarreraCod,
  fechaInicioInscripcion,
  fechaFinInscripcion,
  fechaExamen
}) {
  return {
    MesaExamenCod: id,
    PeridoExamenCod: periodoExamenCod,
    MateriaCarreraCod: materiaCarreraCod,
    InicioFechaInscripcion: formatMesaApiDate(fechaInicioInscripcion),
    FinFechaInscripcion: formatMesaApiDate(fechaFinInscripcion),
    FechaExamenInscripcion: formatMesaApiDate(fechaExamen)
  };
}

export function toBulkUploadMesasPayload(archivoBase64) {
  return { Archivo: archivoBase64 };
}

export function validateMesaForm({ materiaPresent, periodoPresent }) {
  return Boolean(materiaPresent && periodoPresent);
}

export function validateMesaDatesOK(fechaInicioInscripcion, fechaFinInscripcion, fechaExamen) {
  return (
    isCalendarDateOnOrAfter(fechaFinInscripcion, fechaInicioInscripcion)
    && isCalendarDateBefore(fechaFinInscripcion, fechaExamen)
  );
}

export function validateMesaDatesInPeriodo({
  periodoInicio,
  periodoFin,
  fechaExamen,
  fechaInicioInscripcion,
  fechaFinInscripcion
}) {
  const inicio = coerceCalendarDate(periodoInicio);
  const fin = coerceCalendarDate(periodoFin);
  const examen = coerceCalendarDate(fechaExamen);
  const inscripcionInicio = coerceCalendarDate(fechaInicioInscripcion);
  const inscripcionFin = coerceCalendarDate(fechaFinInscripcion);

  if (!inicio || !fin || !examen || !inscripcionInicio || !inscripcionFin) {
    return false;
  }

  return (
    isCalendarDateOnOrAfter(examen, inicio) && isCalendarDateOnOrAfter(fin, examen)
    && isCalendarDateOnOrAfter(inscripcionInicio, inicio) && isCalendarDateOnOrAfter(fin, inscripcionInicio)
    && isCalendarDateOnOrAfter(inscripcionFin, inicio) && isCalendarDateOnOrAfter(fin, inscripcionFin)
  );
}

export function validateBulkUploadForm(base64) {
  return base64?.length > 1;
}
